import * as React from "react";
import { ListSection } from "../../elements/list";
import { DishOptionSetList } from "./dish-option-set-list";
import { DishIngredientsList } from "./dish-ingredients-list";
import { formatCurrency } from "@lib/common";
const noStockStyle = {
    color: `#bd362f`,
    fontWeight: 600,
    textDecoration: `line-through`,
};
export class DishComboChoiceList extends React.Component {
    render() {
        const { choices, detailComboChoiceNames, detailOptionPrices, noStockDishes, noStockOptions } = this.props;
        return (React.createElement("div", null, choices.map((choice, i) => {
            // const selected = choice.selected!;
            const noStock = noStockDishes && noStockDishes.indexOf(choice.id) !== -1;
            return (React.createElement(ListSection, { key: i, className: "text-sm" },
                detailComboChoiceNames && (React.createElement("div", { className: "font-semibold", style: noStock ? noStockStyle : {} },
                    React.createElement("span", { className: "underline" }, choice.choice_name),
                    ": ",
                    choice.name,
                    " ",
                    choice.price ? `(+${formatCurrency(choice.price)})` : "")),
                !detailComboChoiceNames && (React.createElement("div", { className: "font-semibold", style: noStock ? noStockStyle : {} },
                    React.createElement("span", { className: "underline" },
                        choice.name,
                        " ",
                        choice.price ? `(+${formatCurrency(choice.price)})` : ""))),
                React.createElement("div", { className: "pl-2" },
                    choice.options.length > 0 && (React.createElement("div", { className: "mt-1" },
                        React.createElement(DishOptionSetList, { options: choice.options, detailOptionPrices: detailOptionPrices, noStockOptions: noStockOptions }))),
                    choice.ingredients.length > 0 && (React.createElement("div", { className: "mt-1" },
                        React.createElement(DishIngredientsList, { ingredients: choice.ingredients }))))));
        })));
    }
}
//# sourceMappingURL=dish-combo-list.js.map